module.exports = __webpack_public_path__ + "img/title1.8ca4e328.png";